import api from './api';

export interface InchstoneStats {
  total_inchstones: number;
  completed_inchstones: number;
  delayed_inchstones: number;
  completion_percentage: number;
}

export const inchstoneService = {
  /**
   * Get overall inchstone statistics for all transformations
   */
  async getOverallStats(): Promise<InchstoneStats> {
    try {
      const response = await api.get('/inchstones/stats');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching inchstone stats:', error);
      throw error;
    }
  },

  /**
   * Get inchstone statistics for a specific transformation
   */
  async getTransformationStats(transformationId: string): Promise<InchstoneStats> {
    try {
      const response = await api.get(`/inchstones/transformations/${transformationId}/inchstones/stats`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching transformation inchstone stats:', error);
      throw error;
    }
  }
};
